module.exports = __webpack_public_path__ + "main/images/signup/device-illus.268e84c812a3965b6c418fe9e4f520bb.svg";